import {CAMPAIGN_NODE_ID, NEW_OUTPUT_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {z} from 'zod';
import {CardConnectionType} from './cardsConnectionTool.enums';
import describeIdFormat from 'common/src/modules/campaigns/copilot/skills/campaignSetupSkill/idHelpers/utils/describeIdFormat';
import {IdPrefix} from 'common/src/modules/campaigns/copilot/skills/campaignSetupSkill/idHelpers/idHelpers.enums';

interface ConnectionRequest {
  sourceCardId: number;
  sourceCardOutputId: number;
  targetCardId: number;
  type: CardConnectionType;
}

const cardsConnectionToolSchema = z.object({
  connections: z.array(
    z.object({
      sourceCardId: z
        .string()
        .describe(
          `${describeIdFormat(IdPrefix.Card)} For the campaign root card, use ${CAMPAIGN_NODE_ID}.`,
        ),
      sourceCardOutputId: z
        .string()
        .describe(
          `${describeIdFormat(IdPrefix.Output)} For the campaign root card output, use ${NEW_OUTPUT_ID}.`,
        ),
      targetCardId: z.string().describe(describeIdFormat(IdPrefix.Card)),
      type: z.nativeEnum(CardConnectionType).describe('Whether to connect or disconnect the cards'),
    }),
  ),
});

export {cardsConnectionToolSchema, ConnectionRequest};
